'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Offline = function Offline(element) {
    _classCallCheck(this, Offline);

    var fragment = document.createDocumentFragment();
    new _NavigationBarControl2.default(fragment, {
        title: 'Externe opslag niet bereikbaar'
    });

    var div = document.createElement('div');
    div.className = 'viewport';

    var p = document.createElement('p');
    p.innerHTML = 'Helaas kan PRIM de externe opslag niet bereiken en uw gegevens niet ophalen. Zonder externe opslag kunt u niet gebruik maken van deze applicatie. Controleer uw verbinding en probeer opnieuw.';

    var buttonReload = document.createElement('button');
    buttonReload.innerHTML = 'Herstarten en opnieuw proberen';
    buttonReload.onclick = function () {
        location.replace('/');
    };

    div.appendChild(p);
    div.appendChild(buttonReload);
    fragment.appendChild(div);

    element.appendChild(fragment);
};

exports.default = Offline;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/Offline.js
// module id = 20
// module chunks = 0